'use client'
import React from 'react'
import Card from '../card'
import MyImage from '../myImage'
import WeatherPlaceholder from '@/assets/images/placeholder/weather.svg'
import logoIcon from '@/assets/images/logo-icon.svg'
import PitchPlaceholder from '@/assets/images/placeholder/pitch.svg'
import avgScorePlaceholder from '@/assets/images/placeholder/avgScorePlaceHolder.svg'
import logo from '@/assets/images/brand-logo.svg'
import CustomLink from '../customLink'
import Leagues from '../fantasyArticle/leagues'
import Button from '../button'
import { useRouter } from 'next/navigation'
import NoData from '../noData'
import fancy from '@/assets/images/error-images/fancy.svg'

function FantasyOverview({ data, status }: any) {
  const router = useRouter()

  const roles: any = {
    bat: 'Batter',
    bowl: 'Bowler',
    all: 'All Rounder',
    wk: 'Wicket Keeper'
  }

  if (status === 'scheduled' && data) {
    return (
      <div className="container">
        {data?.overViewData?.aCricPrediction[0]?.oSeo?.sSlug && (
          <Card className=" !bg-cardBg flex flex-col p-2 items-center justify-center gap-2 mt-2">
            <label className="font-semibold">CRIC PREDICTION</label>
            <div className="flex justify-between gap-4 px-5 py-2 items-center rounded-lg bg-black">
              <CustomLink
                className="flex items-center gap-2"
                href={`/fantasy-cricket-tips/${data?.overViewData?.aCricPrediction[0]?.oSeo?.sSlug}`}
              >
                <MyImage className="w-6 md:w-8 max-w-none" src={logoIcon} alt="logo" />
                <MyImage
                  className="w-40 md:w-52 max-w-none"
                  src={logo}
                  placeholderImage={logo}
                  alt="logo"
                />
              </CustomLink>
              <span className="text-3xl text-white">{'>'}</span>
            </div>
          </Card>
        )}
        <div className="grid grid-cols-12 md:px-6 mt-4">
          <span className="md:text-2xl text-sm font-bold col-span-6 border-r border-separator text-center">
            {data?.overViewData?.oTeam1?.oTeam?.sTitle}
          </span>
          <span className="md:text-2xl text-sm font-bold col-span-6 text-center">
            {data?.overViewData?.oTeam2?.oTeam?.sTitle}
          </span>
        </div>
        <div className="flex justify-center bg-headersActive py-[9px] md:py-3  items-center text-sm md:text-lg mt-4 md:mt-6">
          PROBABLE PLAYING XI
        </div>
        <div className="grid grid-cols-12 pb-4 md:pb-[70px] pt-3 md:pt-6">
          <div className="col-span-6 border-r border-c">
            <div className="flex flex-col gap-8 md:gap-6">
              {data?.overViewData?.oTeam1?.aPlayers?.map((p: any, i: number) => {
                return (
                  <div key={i} className="flex flex-col">
                    <CustomLink href={`/${p?.oSeo?.sSlug}`}>
                      <span className="text-sm font-medium mb-1.5 md:mb-2 md:text-lg">
                        {p?.sShortName}
                      </span>
                    </CustomLink>
                    <span className="text-textDselected text-xxs md:text-xs">
                      {roles[p?.sPlayingRole]}{' '}
                      {data?.overViewData?.oTeam1?.iC === p?._id ? (
                        <span className="bg-card-600 rounded-full px-2 text-center mx-1">C</span>
                      ) : null}
                    </span>
                  </div>
                )
              })}
            </div>
          </div>
          <div className="col-span-6">
            <div className="flex flex-col items-end text-right gap-8 md:gap-6">
              {data?.overViewData?.oTeam2?.aPlayers?.map((p: any, i: number) => {
                return (
                  <div key={i} className="flex flex-col">
                    <CustomLink href={`/${p?.oSeo?.sSlug}`}>
                      <span className="text-sm font-medium mb-1.5 md:mb-2 md:text-lg">
                        {p?.sShortName}
                      </span>
                    </CustomLink>
                    <span className="text-textDselected text-xxs md:text-xs">
                      {data?.overViewData?.oTeam2?.iC === p?._id ? (
                        <span className="bg-card-600 rounded-full px-2 text-center mx-1">C</span>
                      ) : null}{' '}
                      {roles[p?.sPlayingRole]}
                    </span>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
        <div className="flex justify-center bg-headersActive py-2 text-lg items-center mt-2">
          RESERVE
        </div>
        <div className="grid grid-cols-12 pb-4 pt-3 md:pt-6">
          <div className="col-span-6 border-r border-separator">
            <div className="flex flex-col gap-8 md:gap-6">
              {data?.overViewData?.oTeam1?.aBenchedPlayers?.map((p: any, i: number) => {
                return (
                  <div key={i} className="flex flex-col mt-2">
                    <CustomLink href={`/${p?.oSeo?.sSlug}`}>
                      <span className="text-sm font-medium mb-1.5 md:mb-2 md:text-lg">
                        {p?.sShortName}
                      </span>
                    </CustomLink>
                    <span className="text-textDselected text-xxs md:text-xs">
                      {roles[p?.sPlayingRole]}
                    </span>
                  </div>
                )
              })}
            </div>
          </div>
          <div className="col-span-6 border-separator">
            <div className="flex flex-col gap-8 md:gap-6 items-end text-right">
              {data?.overViewData?.oTeam2?.aBenchedPlayers?.map((p: any, i: number) => {
                return (
                  <div key={i} className="flex flex-col mt-2">
                    <CustomLink href={`/${p?.oSeo?.sSlug}`}>
                      <span className="text-sm font-medium mb-1.5 md:mb-2 md:text-lg">
                        {p?.sShortName}
                      </span>
                    </CustomLink>
                    <span className="text-textDselected text-xxs md:text-xs">
                      {roles[p?.sPlayingRole]}
                    </span>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
        <div className="w-full h-[2px] bg-c"></div>
        <div className="text-lg font-semibold my-4">INJURY AND AVAILABILITY NEWS</div>
        <Card className="text-textDselected border-0">{data?.overViewData?.sNews}</Card>
        <div className="grid grid-cols-12 gap-2 mt-4">
          <div className="col-span-12 lg:col-span-4 gap-2 flex bg-headersActive rounded-xl p-4">
            <MyImage src={WeatherPlaceholder} alt="weather" className="w-12 h-12" />
            <div className="flex flex-col">
              <span className="text-t-700">{data?.overViewData?.sWeatherReport}</span>
              <span className="text-sm">Weather reported</span>
            </div>
          </div>
          <div className="col-span-12 lg:col-span-4 gap-2 flex bg-headersActive rounded-xl p-4">
            <MyImage src={PitchPlaceholder} alt="weather" className="w-12 h-12" />
            <div className="flex flex-col">
              <span className="text-t-700">{data?.overViewData?.sPitchCondition}</span>
              <span className="text-sm">Pitch Condition</span>
            </div>
          </div>
          {/* <div className='col-span-12 lg:col-span-4 gap-2 flex bg-headersActive rounded-xl p-4'>
            <MyImage src={pWin} alt='weather' className='w-12 h-12' />
            <div className='flex flex-col'>
              <span className='text-t-700'>{fantasyArticleData?.overViewData?.oOverview?.oWinnerTeam?.sTitle}</span>
              <span className='text-sm'>Predicted to win</span>
            </div>
          </div> */}
          <div className="col-span-12 lg:col-span-4 gap-2 flex bg-headersActive rounded-xl p-4">
            <MyImage src={avgScorePlaceholder} alt="weather" className="w-12 h-12" />
            <div className="flex flex-col">
              <span className="text-t-700">{data?.overViewData?.sAvgScore}</span>
              <span className="text-sm">Avg. 1st inning score</span>
            </div>
          </div>
        </div>
        <div className="text-lg font-semibold mb-4 mt-4">Pitch Report</div>
        <Card className="text-textOffWhite !border-0">{data?.overViewData?.sPitchReport}</Card>
      </div>
    )
  } else if ((status === 'completed' || status === 'live') && data?.fantasyData) {
    console.log(data?.overViewData?.aCricPrediction)
    return (
      <>
        <div className="flex justify-center mt-4">
          <div className="w-full md:w-[80%]">
            <Leagues
              data={data?.fantasyData?.data?.getFrontFantasyArticle}
              title={false}
              bg={true}
            />
            <div className="flex justify-center items-center mt-2">
              <Button
                className="text-white !border-c bg-transparent hover:!bg-primary-500 hover:text-black"
                onClick={() =>
                  router.push(
                    `/fantasy-cricket-tips/${data?.overViewData?.aCricPrediction[0]?.oSeo?.sSlug}`
                  )
                }
              >
                View Full Article
              </Button>
            </div>
          </div>
        </div>
      </>
    )
  } else if (!data) {
    return (
      <div className="container">
        <NoData imagePath={fancy} />
      </div>
    )
  }
}

export default FantasyOverview
